import { render, staticRenderFns } from "./CotizacionesTemporales.vue?vue&type=template&id=1729b577&lang=pug"
import script from "./CotizacionesTemporales.vue?vue&type=script&lang=js"
export * from "./CotizacionesTemporales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports